import achievement from "@/services/achievement"

export const mutations = {
  setAchievementEvents: 'SET_ACHIEVEMENT_EVENTS',
  updateAchievementEvent: 'UPDATE_ACHIEVEMENT_EVENT',
}

export default {
  [mutations.setAchievementEvents](state, payload) {
    state.achievementEvents = payload
  },
  [mutations.updateAchievementEvent](state, payload) {
    const event = state.achievementEvents.find((achievementEvent) => achievementEvent.eventId === payload.eventId)

    if (event) {
      const editIndex = state.achievementEvents.findIndex((achievementEvent) => achievementEvent.eventId === payload.eventId)
      const eventUpdated = { ...event, rewardWasCollected: payload.userCollectedReward }
      state.achievementEvents.splice(editIndex, 1, eventUpdated)
    }
  }
}
